import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./InsuranceSection.css";

const InsuranceCard = React.memo(({ product }) => {
  const navigate = useNavigate();
  const routeMap = {
    life_insurance: "/life-insurance",
    health_insurance: "/health-insurance",
    car_insurance: "/car-insurance",
    home_insurance: "/home-insurance",
    travel_insurance: "/travel-insurance",
    business_insurance: "/business-insurance",
    general_insurance: "/car-insurance",
  };
  const iconMap = {
    life_insurance: "❤️",
    health_insurance: "🩺",
    car_insurance: "🚗",
    home_insurance: "🏠",
    travel_insurance: "✈️",
    business_insurance: "💼",
    general_insurance: "🛡️",
  };

  const route = routeMap[product.slug] || "/life-insurance";
  const icon = iconMap[product.slug] || "🛡️";

  let features = [];
  try {
    features = JSON.parse(product.features || "[]");
  } catch (e) {
    /* ignore */
  }

  return (
    <div className="ins-card" onClick={() => navigate(route)}>
      <div className="ins-icon-box">{icon}</div>
      <h3 className="ins-card-title">{product.name}</h3>
      <p className="ins-card-desc">{product.description}</p>
      <p className="ins-card-feature">
        {features[0] ? `✨ ${features[0]}` : "Get Quotes"}
      </p>
      <button className="ins-card-btn">
        {product.button_text || "View Plans"}
      </button>
    </div>
  );
});

const InsuranceSection = () => {
  const { subServices, loading, error } = useSelector(
    (state) => state.subService,
  );

  const insuranceProducts = React.useMemo(() => {
    return (subServices || [])
      .filter((p) => p.service_id === 2)
      .sort((a, b) => a.order - b.order);
  }, [subServices]);

  const staticFallback = [
    {
      id: 1,
      slug: "life_insurance",
      name: "Life Insurance",
      description: "Family security first",
      button_text: "View Plans",
    },
    {
      id: 2,
      slug: "health_insurance",
      name: "Health Insurance",
      description: "Medical emergency cover",
      button_text: "View Plans",
    },
    {
      id: 3,
      slug: "car_insurance",
      name: "Car Insurance",
      description: "Vehicle damage protection",
      button_text: "View Plans",
    },
    {
      id: 4,
      slug: "home_insurance",
      name: "Home Insurance",
      description: "Secure your dream home",
      button_text: "View Plans",
    },
    {
      id: 5,
      slug: "travel_insurance",
      name: "Travel Insurance",
      description: "Worldwide safe travel",
      button_text: "View Plans",
    },
    {
      id: 6,
      slug: "business_insurance",
      name: "Business Insurance",
      description: "Corporate risk cover",
      button_text: "View Plans",
    },
  ];

  const displayProducts = insuranceProducts.length
    ? insuranceProducts
    : staticFallback;

  if (loading) return <div className="ins-status">Loading Products...</div>;
  if (error)
    return <div className="ins-status ins-error">Error loading insurance.</div>;

  return (
    <section id="insurance" className="ins-section">
      <div className="ins-container">
        <div className="ins-header">
          <h2>Insurance for Everyone</h2>
          <p>Protect what matters most with our top plans</p>
        </div>
        <div className="ins-grid">
          {displayProducts.map((p) => (
            <InsuranceCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsuranceSection;
